export default "__VITE_ASSET__c9e66b28__"